import FullLayout from '@/modules/core/layouts/FullLayout.vue';
import ViewVision from './ViewVision.vue';

export default {
  path: '/dashboards',
  component: FullLayout,
  meta: { requiresAuth: true },
  children: [
    { name: 'graficoDeVendas', path: 'visiontwo', component: ViewVision },
  ],
};
